import { Helmet } from 'react-helmet';
import QuickFilterListCreatorLayout from './QuickFilterListCreatorLayout';
import {
  GROUP_NAMES_REPEAT,
  GROUP_NAMES_TOO_SHORT,
  LIST_SIZE_LIMIT,
  SUPPORTER_DATA_LOADING,
} from './quickFilterListCreatorConstants';
import {
  QuickFilterListCreatorPageProps,
  useQuickFilterListCreatorPage,
} from './useQuickFilterListCreatorPage';

export {
  GROUP_NAMES_REPEAT,
  GROUP_NAMES_TOO_SHORT,
  LIST_SIZE_LIMIT,
  SUPPORTER_DATA_LOADING,
};

export default function QuickFilterListCreatorPage(props: QuickFilterListCreatorPageProps) {
  const page = useQuickFilterListCreatorPage(props);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Manager - Quick Search</title>
        <meta name="description" content="List Manager - Quick Search" />
      </Helmet>
      <QuickFilterListCreatorLayout {...page} />
    </>
  );
}
